import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]
  static classes = ["active"]

  select(event) {
    this.tabTargets.forEach(tab => tab.classList.remove(...this.activeClasses))
    event.currentTarget.classList.add(...this.activeClasses)
  }
}
